import NbciUsInvoiceApiUrls from '../../../apiUrls/NbciUsInvoiceApiUrls'
import { CodeMaintenanceType } from 'src/constants/nacodemaintenance'
import { components} from 'cng-web-lib'
import PropTypes from 'prop-types'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { useServices } from 'cng-web-lib'
const {
  card: {
    CngSimpleCardHeader,
  },
  form: {
    field: {
      CngTextField,
      CngLookupAutocompleteField,
      CngServerSideAutocompleteField
    },
  },
  CngGridItem,
} = components

/**
 *
 * @visibleName Code maintenance autocomplete
 */
function NbciUSInvoiceAutoCompleteMasterField(props, codeMaintenanceType) {

  const {createRecord} = useServices()
  const history = useHistory()
  var codeMType = ""

  const {
    lookupProps = {},
    ...lookupAutocompleteProps
  } = props
  const { filters = [], ...otherLookupProps } = lookupProps

  return (
    <CngServerSideAutocompleteField
      {...lookupAutocompleteProps}
      minFilterChars={1}
      debounceInterval={1000}
      openOnFocus={true}
      onMouseDownCapture={(e) => e.stopPropagation()}
      searchableFields={['templateName']}
      lookupPageableProps={{
        customData: { "filters":filters},
        url: NbciUsInvoiceApiUrls.GET,
        label: 'templateName',
        value: 'templateName',
        filters: [
          {
            field: 'invHeaderstatus',
            operator: 'equal',
            value: '1002'
          },
          ...filters
        ],
        pageSize: 1000,
        ...otherLookupProps
      }}
    />
  )
}

NbciUSInvoiceAutoCompleteMasterField.propTypes = {
  /** @ignore */
  codeMaintenanceType: PropTypes.oneOf(Object.values(CodeMaintenanceType))
    .isRequired,
  /** @ignore */
  lookupProps: PropTypes.object
}

export default NbciUSInvoiceAutoCompleteMasterField
